import React, { useState, useEffect } from 'react';
import { Button, Loader, Modal } from 'semantic-ui-react';

import { useUserDispatch, tabActive } from '../../../context/UserContext';
import { deleteMasterCertificate } from '../../../api/api';
import {useAuth0} from "@auth0/auth0-react";

const DeleteMasterCertificate = (props) => {
  const userDispatch = useUserDispatch();

  const [loading, setLoading] = useState(false);
  const [, setErrorStatus] = useState();
  const [, setErrorDetail] = useState();
  const [, setHasError] = useState(false);
  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    if (window.location.pathname === `/master-certificates`) {
      tabActive(userDispatch, 2);
    }
    window.localStorage.setItem('main_tab', 'certificates');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deleteMasterCert = () => {
    setLoading(true);

    deleteMasterCertificate({ logout, getAccessTokenSilently }, props.masterCertificateId)
      .then((res) => {
        props.onCloseSuccessfully();
      })
      .catch((err) => {
        setHasError(true);
        setErrorStatus(err.response.data.status);
        setErrorDetail(err.response.data.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className='payload'>
      { loading ? (
        <div className='empty-table'>
          <Loader active indeterminate size='small' />
        </div>
      ) : (
        <Modal
            open={props.open}
            onClose={props.onClose}
            >
            <Modal.Header>Delete Master Certificate</Modal.Header>
            <Modal.Content>
                Are you sure you want to delete Master Certificate: '{props.masterCertificateId}' ?
            </Modal.Content>
            <Modal.Actions>
                 <Button onClick={props.onClose}>
                    Close
                  </Button>
                <Button negative onClick={deleteMasterCert}>
                Delete
                </Button>
            </Modal.Actions>
            </Modal>
      )}
    </div>
  )
}

export default DeleteMasterCertificate
